import Glide from "@glidejs/glide";
let glide = null;

function initHeroSlider(id) {
    glide = new Glide('#' + id, {
        type: 'carousel',
        rewind: false, 
        bound: true,
        startAt: 0,
        autoplay: 5000,
        gap: 30,
        perView: 1,
        breakpoints: {
            900: {
                perView: 1,
                gap: 20,
            }
        }
    });
    
    glide.mount();
}

export function moveGlide(whichWay) {
    glide.go(whichWay);
}

window.initHeroSlider = initHeroSlider;